import { FunctionComponent as F } from "react";
import { useSelector } from "react-redux";
import { IState } from "../../core/store/store";
import ProtocolListItem from "./ProtocolListItem";
import FolderListItem from "./FolderListItem";
import { Box } from "@mui/material";



interface IProps
{
  folderId?: number,
  indent?: number,
  drawerOpen: boolean
}


const MyProtocolsList: F<IProps> = (props: IProps) =>
{
  const user = useSelector((state: IState) => state.user);
  const myProtocols = useSelector((state: IState) => state.protocol.protocols.filter(p =>
    (user.premium ? p.folderId === props.folderId : true) && p.userId === user.userId));
  const folders = useSelector((state: IState) =>
    state.protocol.folders.filter(f => f.parentFolderId === props.folderId));

  return (
    <Box sx={{ pl: (props.folderId ? 8 : 0) + 'px' }}>
      {folders.map((f, i) => <FolderListItem {...props} key={i} folderId={f.folderId}/>)}
      {myProtocols.map((p, i) => <ProtocolListItem {...props} key={i} protocolId={p.protocolId}/>)}
    </Box>);
}

export default MyProtocolsList;